<template>
  <div class="slide-up-container">
    <div class="slide-up-text" v-html="currentText"></div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'This is the text that will be typed.'
    },
    delays: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  computed: {
    currentText () {
      let copy = this.text
      const copyArray = copy.split('</span>')
      for(let i = 0; i < copyArray.length; i++) {
        let formatted = `${copyArray[i]}</span></span>`
        formatted = formatted.replace('<span>', `<span><span class="slide" style="animation-delay: ${this.delays[i] || i * (i*0.02)}s">`)
        copyArray[i] = formatted
      }
      return copyArray.join('')
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';

.slide-up-container {
  ::v-deep .slide-up-text {
    > span {
      display: inline-block;
      overflow: hidden;

      .slide {
        transform: translateY(110%);
      }

      @for $i from 0 through 20 {
        &:nth-child(#{$i}) .slide {
          animation: slide 1s $ease-expo #{$i * ($i * 0.01)}s 1 normal forwards;
        }
      }
    }
    
    .slide {
      display: inline-block;
    }
  }
}

@keyframes slide {
  from {
    transform: translateY(110%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
